import { ApiRouteType } from '@core/interfaces/core-services';
import BPCApiRouteService from '@modules/core/services/bpc-api-route.service';

export default abstract class BPCAbstractRequestService {
  protected $bpcRouter: BPCApiRouteService;

  abstract get(path: string, config?: object);

  abstract delete(path: string, config?: object);

  abstract post(
    path: string,
    body?: any,
    config?: object,
    apiRouteType?: ApiRouteType,
    withDraft?: boolean,
  );

  abstract put(
    path: string,
    body?: any,
    config?: object,
    apiRouteType?: ApiRouteType,
    withDraft?: boolean,
  );
}
